import Modal  from 'react-bootstrap/Modal';
import Reference from './Reference';

function DesignerDetails({
    designer, setDesigner,
    loadedReferences, setLoadedReferences
}) {

    return (<div className="DesignerDetails">
        <Modal show={true} backdrop="static" onHide={() => setDesigner(undefined)} keyboard={false} centered size="lg" scrollable fullscreen="sm-down">
            <Modal.Header closeButton className='modal-header'>
                <div className='d-flex align-items-center'>
                    <div className='profileMini me-3'>
                        <img
                            src={`https://hatscripts.github.io/circle-flags/flags/${designer.country.toLowerCase()}.svg`}
                            className='flag'
                            alt={designer.cca2}
                        />
                        <img
                            src={designer.avatar}
                            alt='profile'
                            className='img-fluid'
                        />
                    </div>
                    <Modal.Title>{designer.firstName} {designer.lastName}</Modal.Title>
                </div>
            </Modal.Header>
            <Modal.Body>
                <hr className='rounded' />
                <div className='row px-3'>
                    {designer.references && designer.references.map((reference) => (
                        <Reference reference={reference} key={reference.url} />
                    ))}
                </div>
            </Modal.Body>
            {/* <Modal.Footer className='modal-footer'>
                <button className="btn btn-primary btn-sm" onClick={handleSelectDesigner}>Select</button>
            </Modal.Footer> */}
        </Modal>
    </div>);
}

export default DesignerDetails;